import { number } from './number';

export const fr = {
  translation: {
    common: {
      logInText: 'Connectez-vous',
      signInButton: 'Je me connecte',
      infoUnavailable: 'Info indisponible',
      infoBoxConnection:
        'Utilisez les identifiants du compte meilleurtaux Placement créés lors de votre parcours de souscription ou sur l’application mobile. Si vous n’avez jamais créé de compte, cliquez sur “Mot de passe oublié”.',
      notCustomer: 'Pas encore client ?',
      discoverOffers: 'Découvrez nos offres',
      edit: 'Modifier',
      continue: 'Continuer',
      update: 'Mettre à jour',
      myWallet: 'Mon portefeuille',
      tryAgain: 'Réessayer',
      privateExchange: 'Bourse Privée',
      mySpace: 'Mon espace',
      return: 'Retour',
      welcome: 'Bonjour',
      subscribeContract: 'Souscrire un nouveau contrat',
      noDataText: 'Pas de données disponibles.',
      movements: 'Tous les mouvements',
      noTransaction: 'Aucune opération',
      advisorView: 'Vue conseiller',
      distribution: 'Ma répartition',
      masculineDeterminer: 'Le',
      backToHome: "Retour à l'accueil",
      closeNotification: 'Fermer la notification',
      cancel: 'Annuler',
      close: 'Fermer',
      documentsTab: 'Documents',
      otherDocumentsTab: 'Autres documents',
      documentsCardDescription: "Consultez l'ensemble des documents de votre contrat sur :",
      validateButton: 'Valider',
      declineButton: 'Refuser',
      cancelableCTA: 'Renoncer au contrat',
      retractableCTA: 'Se rétracter',
      arbitrageProposals_one: 'Opération en attente',
      arbitrageProposals_other: 'Opérations en attente',
    },
    cardGererContrat: {
      description: 'Pour consulter et gérer votre Contrat, rendez-vous sur :',
      familyDescription: 'Consultez et gérez votre contrat sur :',
      partnerSpaceBtn: 'Espace gestionnaire',
      comingSoon: 'Et bientôt directement dans votre espace client !',
    },
    signInForm: {
      forgotPassword: 'Première connexion / Mot de passe oublié',
      genericError: 'Une erreur est survenue, veuillez réessayer',
      sessionExpired: 'Vous avez été déconnecté',
      sessionExpiredDescription: 'Pour votre sécurité, votre session a expiré. Veuillez vous reconnecter.',
    },
    dashboard: {
      label: 'Projet de placement',
      subtitle: 'Mes souscriptions à finaliser',
      exploreProductsLabel: 'Découvrez nos offres et produits',
      contracts_one: 'Mon contrat',
      contracts_other: 'Mes contrats',
      contractsInProgress_one: 'Contrat en cours de traitement',
      contractsInProgress_other: 'Contrats en cours de traitement',
      prospectSansContrat:
        'Souscrivez à un contrat pour avoir accès à vos performances et mieux gérer vos investissements.',
      prospectEnTraitement: 'Vous pourrez bientôt accéder à vos performances.',
    },
    invest: {
      title: 'Investir',
      subtitle:
        "Découvrez notre gamme d'investissement et complétez votre portefeuille avec une nouvelle catégorie de placement.",
      offersTitle: 'Découvrez nos offres du moment',
      cards: {
        buttonLabel: 'Découvrir',
        assuranceVie: {
          title: 'Assurance Vie',
          text: "Faites fructifier votre capital et bénéficiez d'une fiscalité avantageuse.",
        },
        per: {
          title: 'Plan Épargne Retraite - PER',
          text: "Prévoyez aujourd'hui, vivez sereinement demain.",
        },
        livret: {
          title: "Livret d'épargne",
          text: 'Une épargne disponible et sécurisée.',
        },
        defiscalisation: {
          title: 'Défiscalisation',
          text: 'Réduisez vos impôts, maximisez vos projets.',
        },
        scpiImmobilier: {
          title: 'SCPI & Immobilier',
          text: 'Développez votre patrimoine, bâtissez votre avenir.',
        },
        bourse: {
          title: 'Bourse',
          text: 'Investissez en direct via notre PEA ou notre offre Bourse Privée.',
        },
      },
    },
    carrousel: {
      labelButton: 'Découvrir',
      missingDataTitle: "Erreur d'affichage",
      missingDataDescription: 'Cette section est actuellement indisponible.',
    },
    slider: {
      previousSlide: 'Slide précédente',
      nextSlide: 'Slide suivante',
      goToSlide: 'Aller à la slide',
      previous: 'Précédent',
      next: 'Suivant',
      pause: 'Mettre en pause',
      play: 'Lancer le défilement',
    },
    partnerInfo: {
      title: 'Accès espaces gestionnaires',
      label: 'Accéder à mon espace gestionnaire',
      cardLinkLabel: 'Accéder à mon espace',
      directAccessDescription: "Accéder à l'espace de mon gestionnaire de contrat",
    },
    loginAccess: {
      mainTitle: 'Mon espace client',
      mainSubtitle: 'Meilleurtaux Placement',
      benefitPerformance: 'Suivez la performance de votre épargne',
      benefitContracts: 'Consultez vos contrats',
      benefitAdvisor: 'Un conseiller à votre écoute, sur simple demande',
      partnerTitle: "Accéder à l'espace de mon",
      partnerSubtitle: 'Gestionnaire de contrat',
      partnerButton: "Continuer vers l'espace gestionnaires",
      stockExchangeTitle: 'Accéder à mon espace',
      stockExchangeSubtitle: 'Abonnement Bourse Privée',
      stockExchangeButton: "Continuer vers l'espace Bourse Privée",
    },
    autresAcces: {
      title: 'Mes autres accès',
      gestionnairesTitle: 'Espace gestionnaires',
      gestionnairesDescription: 'Accédez à votre espace de gestion de contrat.',
      gestionnaireCardLabel: 'Contrats {{gestionnaire}}',
      bourseTitle: 'Espace Bourse Privée',
      bourseDescription: 'Accédez à votre abonnement Bourse Privée ou <link>découvrez le service</link>.',
      bourseDescriptionLinkLabel: 'Découvrez le service Bourse Privée',
      bourseSpaceLabel: 'Mon espace',
      bourseSubscriptionLabel: 'Bourse Privée',
      bourseButtonLabel: 'Je me connecte',
    },
    resetPassword: {
      label: 'Votre email',
      description:
        'Veuillez renseigner votre email, nous vous enverrons un lien pour réinitialiser votre mot de passe ou en créer un nouveau en toute sécurité.',
      button: 'Envoyer',
    },
    helpInfo: {
      label: 'Besoin d’aide ?',
      description:
        'Vous avez besoin d’échanger avec l’un de nos conseillers expert, vous avez des questions ?\nNous nous tenons à votre disposition.',
      descriptionCard: 'Un conseiller se tient à votre disposition pour vous accompagner et vous guider.',
      chatButton: 'Échanger avec un conseiller',
      chatWithAdvisorLabel: 'Échanger avec un conseiller',
      callbackRequestLabel: 'Être rappelé par un conseiller',
      contactAdvisorLabel: 'Joindre un conseiller',
      wording: 'Le chat est actuellement disponible',
      chatUnavailableMessage: 'Le chat est actuellement indisponible',
      callbackDescription: 'L’un de nos conseillers expert vous rappelle au créneau de votre choix',
      phoneAvailabilityMessage: 'Nos conseillers, joignables par téléphone en semaine et le weekend',
    },
    userInfo: {
      title: 'Mes informations personnelles',
      subTitle: 'Mes coordonnées',
      personalDataSubtitle: 'Mes données personnelles',
      tooltipTitle: 'De quoi s’agit-il ?',
      tooltipText:
        'Ces informations nous permettent de vous accompagner au mieux dans la gestion de vos placements. Elles sont déclaratives et utilisées uniquement dans le cadre de la gestion de votre dossier, conformément à la réglementation en vigueur.',
      description:
        'Si vos données personnelles ont changé (situation maritale, patrimoine financier), vous pouvez les mettre à jour ici.',
      subTitleKYC: 'Mes informations',
    },
    operations: {
      title: 'Mes opérations',
      pendingTitle_one: 'Opération en attente',
      pendingTitle_other: 'Opérations en attente',
      subTitle: 'Effectuer une opération',
      selectContract: 'Choisir un contrat',
      description: 'Sélectionnez le contrat pour lequel vous souhaitez faire un ',
      descriptionDefault: 'Sélectionnez le contrat pour lequel vous souhaitez faire une opération.',
      modalTitle: 'Le versement s’effectue depuis votre compte de confiance',
    },
    valuation: {
      amount: number.currency.noGrouping_hundredth,
    },
    supports: {
      supportNameLabel: 'Nom du support',
      valueChangeLabel: '+/- valeur',
      valueLabel: 'Valeur',
      currentPriceLabel: 'Prix actuel',
      unitCostPriceLabel: 'Prix revient unit.',
      quantityLabel: 'Quantité',
      copyIsinLabel: 'Copier le code ISIN',
      isinCopied: 'ISIN copié !',
    },
    depositCard: {
      title: 'Réalisez un versement libre',
      description:
        'Faites grandir votre épargne et boostez votre capital en effectuant des versements libres à tout moment.',
      buttonText: 'Faire un versement',
      versementLivretModalTitle: 'Le versement s’effectue depuis votre compte de confiance',
      versementLivretModalBtnLabel: 'Retour à l’accueil',
    },
    errorBoundary: {
      errorTitle: 'Une erreur est survenue',
      loadingErrorMessage: 'Nous rencontrons un problème dans le chargement de la page.',
      retryLaterMessage: 'Veuillez réessayer ultérieurement.',
    },
    cardProjectInvestment: {
      title: 'Dynamiser votre épargne',
      description: 'Découvrez notre gamme de produits financiers et trouvez la solution d’épargne qui vous correspond.',
      buttonText: 'Découvrir nos produits',
    },
    errorPage: {
      title: 'Une erreur est survenue',
      loadingErrorMessage: 'Nous rencontrons un problème dans le chargement de la page.',
      retryLaterMessage: 'Veuillez réessayer ultérieurement.',
      serviceIncidentMessage:
        'Un incident affecte la connexion à l’espace client. Nos équipes techniques sont mobilisées pour rétablir le service.',
      apologiesMessage: 'Veuillez nous excuser pour la gêne occasionnée.',
      buttonText: "Retour à la page d'accueil",
    },
    redirectionMail: {
      title: 'La suite dans votre boîte mail',
      wording: 'Un mail de réinitialisation va être envoyé à l’adresse',
      resetLinkInstruction:
        'Cliquez sur le lien contenu dans celui-ci afin de réinitialiser votre mot de passe ou en créer un nouveau.',
      checkSpamMessage: 'Vérifiez vos spams et courriers indésirables !',
      linkWording: 'Recevoir à nouveau le mail de réinitialisation',
      passwordFoundMessage: 'Vous avez retrouvé votre mot de passe ?',
    },
    helpContact: {
      title: 'Besoin d’aide ?',
      wording: 'Une question ?',
      callbackSuggestion: 'Faites-vous rappeler par un expert.',
      phoneContactMessage: 'Vous pouvez aussi nous contacter par téléphone au',
      callCostMessage: '(prix d’un appel normal).',
      availabilitySchedule: 'Du lundi au vendredi de 9h à 19h et le samedi de 9h à 17h.',
      label: 'Votre n° de téléphone',
      callbackTimeLabel: 'Quand souhaitez-vous être rappelé ?',
      callbackReasonLabel: 'Expliquez-nous en quelques mots l’objet du rappel (facultatif)',
      callbackReasonPlaceholder: 'Posez-nous une question ou expliquez-nous ce qui mériterait d’être plus clair.',
      callbackTimeslotLabel: 'Créneau horaire',
      buttonText: 'Valider le rappel',
      tel: '01 47 20 33 00',
      requestConfirmation: 'Votre demande a bien été prise en compte.',
      advisorCallback: 'Un conseiller vous recontactera sur le créneau demandé',
      backToHome: "Retour à l'accueil",
      fieldRequired: 'Champs requis',
      invalidPhone: 'Numéro invalide',
    },
    inputFile: {
      label: 'Zone de dépôt de fichier pour votre {{label}}',
      maxSizeError: 'Le fichier ne doit pas excéder 4 Mo',
    },
    trendingValue: {
      currency: number.currency.noGrouping_hundredth,
      percent: number.percent.noGrouping_hundredth,
      positiveSign: '+',
      negativeSign: '-',
      unavailablePerformance: 'Performance indisponible',
    },
    documents: {
      exPostReport_one: 'Rapport de frais ex-post',
      exPostReport_other: 'Rapports de frais ex-post',
      regularReport_one: 'Rapport de conseil régulier',
      regularReport_other: 'Rapports de conseil régulier',
      paymentReport_one: 'Bulletin de versement',
    },
    format: {
      number: number.decimal.grouping_integer,
      numberWithDecimals: '{{value, number(useGrouping: true; minimumFractionDigits: 2; maximumFractionDigits: 2)}}',
      numberFlexible:
        '{{value, number(useGrouping: true; minimumFractionDigits: 2; maximumFractionDigits: 2; trailingZeroDisplay: stripIfInteger)}}',
      numberSignificant: number.decimal.grouping_significant,
      numberFlexibleTenth: number.decimal.noGrouping_flexibleTenth,
      currency: number.currency.noGrouping_hundredth,
      currencyInteger: number.currency.noGrouping_integer,
      currencyFlexible: number.currency.noGrouping_flexible,
      percent: number.percent.noGrouping_hundredth,
      percentFlexible: number.percent.noGrouping_flexible,
    },
    lifeInsurance: {
      title: 'Détail de mon contrat',
      description: 'Dernière valorisation le',
      subtitle: 'Gérer mon contrat',
      paymentSlipsSubtitle: 'Bulletins de versement',
      contractNumberLabel: 'N° DE CONTRAT',
      openingDateLabel: 'DATE D’OUVERTURE',
      investmentHorizonLabel: 'HORIZON DE PLACEMENT',
      managementModeLabel: 'MODE DE GESTION',
      initialDepositLabel: 'VERSEMENT INITIAL',
      scheduledDepositLabel: 'VERSEMENT PROGRAMMÉ',
      debitFrequencyLabel: 'FRÉQUENCE DE PRÉLÈVEMENT',
      totalPaidLabel: 'MONTANT TOTAL VERSÉ',
      totalRedeemedLabel: 'MONTANT TOTAL RACHETÉ',
    },
    retirement: {
      title: 'Détail de mon contrat',
      description: 'Dernière valorisation le',
      subtitle: 'Gérer mon contrat',
      paymentSlipsSubtitle: 'Bulletins de versement',
      contractNumberLabel: 'N° DE CONTRAT',
      openingDateLabel: 'DATE D’OUVERTURE',
      investmentHorizonLabel: 'HORIZON DE PLACEMENT',
      managementModeLabel: 'MODE DE GESTION',
      initialDepositLabel: 'VERSEMENT INITIAL',
      scheduledDepositLabel: 'VERSEMENT PROGRAMMÉ',
      totalPaidLabel: 'MONTANT TOTAL VERSÉ',
      totalRedeemedLabel: 'MONTANT TOTAL RACHETÉ',
    },
    taxExemption: {
      title: 'Détail de mon contrat',
      description: 'Dernière valorisation le',
      performanceWithoutTaxBenefit: 'PERFORMANCE HORS AVANTAGE FISCAL',
      performanceWithTaxBenefit: 'PERFORMANCE AVEC AVANTAGE FISCAL',
      managedByLabel: 'GÉRÉ PAR',
      statusLabel: 'STATUT',
      categoryLabel: 'CATÉGORIE',
      yearLabel: 'ANNÉE',
      initialDepositLabel: 'VERSEMENT INITIAL',
      taxReductionLabel: 'RÉDUCTION D’IMPÔT',
      minLockupLabel: 'BLOCAGE MIN.',
      lockupUntilLabel: 'jusqu’au',
      maxLockupLabel: 'BLOCAGE MAX.',
      lastManagementReportLabel: 'DERNIER RAPPORT DE GESTION',
    },
    realEstate: {
      title: 'Détail de mon contrat',
      distributionRateTitle: 'Taux de distribution',
      resalePriceEvolutionTitle: 'Évolution du prix de revente',
      roiTitle: 'TRI',
      description: 'Dernière valorisation le',
      label: 'GÉRÉ PAR',
      subscriptionDateLabel: 'DATE DE SOUSCRIPTION',
      typeLabel: 'TYPE',
      acquisitionModeLabel: 'MODE D’ACQUISITION',
      numberOfSharesLabel: 'NOMBRE DE PARTS',
      purchasePriceLabel: 'PRIX D’ACHAT (FRAIS INCLUS)',
      resalePriceLabel: 'PRIX DE REVENTE À DATE',
      initialDepositLabel: 'VERSEMENT INITIAL',
      lastManagementReportLabel: 'DERNIER RAPPORT DE GESTION',
      infoUnavailable: 'Non disponible',
    },
    savingsAccount: {
      title: 'Détail de mon contrat',
      description: 'Dernière valorisation le',
      subtitle: 'Les modalités d’opérations du livret',
      manageContractSubtitle: 'Gérer mon contrat',
      balanceAsOfSubtitle: 'Solde au',
      label: 'N° DE CONTRAT',
      openingDateLabel: 'DATE D’OUVERTURE',
      standardInterestRateLabel: 'TAUX D’INTÉRÊT STANDARD',
      boostedInterestRateLabel: 'TAUX D’INTÉRÊT BOOSTÉ',
      initialDepositLabel: 'VERSEMENT INITIAL',
      totalPaidLabel: 'MONTANT TOTAL VERSÉ',
      totalRedeemedLabel: 'MONTANT TOTAL RACHETÉ',
    },
    modals: {
      scheduledPaymentInfoModal: {
        descriptionText:
          'Si vous avez effectué un changement dans vos versements programmés, il apparaîtra dans les prochains jours.',
      },
      realEstateBareOwnershipInfoModal: {
        titleText: 'À quoi correspond ce montant ?',
        descriptionText: 'Cette valorisation représente la somme que vous pourriez récupérer au terme du démembrement.',
      },
      realEstateUsufructInfoModal: {
        titleText: 'Pourquoi ce montant est-il égal à 0€ ?',
        descriptionText: 'Les parts en usufruit ne sont pas valorisées en capital.',
      },
      realEstateRoiInfoModal: {
        subTitle: "Qu'est ce qu'un TRI ?",
        descriptionText:
          'Le TRI (taux de rendement interne) est un <b>indicateur de la performance passée de la SCPI</b> (sur une période de 5 ans ou 10 ans) qui tient compte de la revalorisation du patrimoine (plus ou moins value) et des dividendes perçus, net de tous les frais.',
      },
      realEstatePayoutRateInfoModal: {
        titleText: "Qu'est ce qu'un taux de distribution pour les SCPI ?",
        descriptionText:
          "Le Taux de Distribution fournit la <b>rentabilité de l'investissement sur une année</b> (frais de gestion inclus). Il est calculé en faisant le rapport entre le montant total des dividendes perçus sur l'année rapporté au prix d'achat au 1er janvier de l'année (ou au prix d'achat moyen de l'année pour les calculs effectués avant le 01/01/2022).",
      },
      fixedCapitalInfoModal: {
        descriptionText: `La revente des parts de SCPI à capital fixe s'effectue sur un marché secondaire, soumis aux mécanismes de
              l'offre et la demande. Il en résulte une incertitude quant à la valorisation des parts, ainsi qu'un risque
              d'allongement du délai de retrait en cas de volonté de cession.`,
      },
      mobilephoneBillModal: {
        title: 'Facture de téléphone mobile',
        introPrefix: 'Une',
        introHighlight: 'facture de téléphone mobile à votre nom.',
        alternativeTitle: "À défaut une attestation sur l'honneur :",
        declarationText:
          '"Je soussigné M.[Nom] [Prénom], atteste être le seul utilisateur de la ligne de téléphone portable n° [06...] et être le seul destinataire des messages parvenant sur cette ligne téléphonique.',
        locationDateText: 'Fait à [Ville], le [xx/xx/xx]',
        signatureText: 'Votre signature manuscrite"',
        btnLabel: "J'ai compris",
      },
      demoBlockedModal: {
        title: 'Vous êtes actuellement dans le mode démo',
        message1:
          'Toutes les informations présentées (montants, contrats, graphiques) sont des exemples créés à des fins de démonstration uniquement.',
        message2: 'Pour continuer sur votre espace client avec vos contrats et montants réels, quittez le mode démo.',
        stayButton: 'Rester en mode démo',
        quitButton: 'Revenir à mon espace client',
      },
      savingsAccountStandardRateModal: {
        titleText: "À quoi correspond le taux d'intérêt standard ?",
        btnLabel: "J'ai compris",
        demoBlockedModal: {
          title: 'Vous êtes actuellement dans le mode démo',
          message1:
            'Toutes les informations présentées (montants, contrats, graphiques) sont des exemples créés à des fins de démonstration uniquement.',
          message2: 'Pour continuer sur votre espace client avec vos contrats et montants réels, quittez le mode démo.',
          loginButton: 'Quitter le mode démo',
        },
        savingsAccountBoostedRateModal: {
          titleText: "À quoi correspond le taux d'intérêt boosté ?",
          btnLabel: "J'ai compris",
        },
      },
      cancelableModal: {
        title: 'Renoncer au contrat {{nomContrat}}',
        text1:
          'Votre demande va être transmise à notre équipe. Pour la valider définitivement, vous recevrez un email intitulé "Meilleurtaux Placement - Suivi de votre demande de renonciation" contenant un document à signer.',
        text2:
          'Ce document devra être signé et adressé dans un délai de {{delayDays}} jours calendaires révolus, à compter de la date de signature de votre bulletin de souscription.',
        text3: 'Nous vous ferons parvenir un accusé de réception après traitement de votre dossier.',
        cancelButton: 'Annuler ma demande',
        validateButton: 'Confirmer ma renonciation',
        requestSentText: 'Demande de renonciation envoyée',
        text4: 'Surveillez vos emails pour signer votre demande de renonciation.',
        backButton: 'Fermer',
        pendingText: 'Envoi en cours...',
        errorMessage: 'Une erreur est survenue lors de la renonciation. Veuillez réessayer.',
        retractation: {
          title: 'Se rétracter du contrat {{nomContrat}}',
          text1:
            'Votre demande va être transmise à notre équipe. Pour la valider définitivement, vous recevrez un email intitulé "Meilleurtaux Placement - Suivi de votre demande de rétractation" contenant un document à signer.',
          validateButton: 'Confirmer ma rétractation',
          requestSentText: 'Demande de rétractation envoyée',
          text4: 'Surveillez vos emails pour signer votre demande de rétractation.',
          errorMessage: 'Une erreur est survenue lors de la rétractation. Veuillez réessayer.',
        },
        suravenirPopupBlockedError:
          "Impossible d'ouvrir la page de renonciation Suravenir. Veuillez désactiver le bloqueur de pop-ups et réessayer.",
        demoBlockedModal: {
          title: 'Vous êtes actuellement dans le mode démo',
          message:
            'Toutes les informations présentées (montants, contrats, graphiques) sont des exemples créés à des fins de démonstration uniquement. Pour continuer sur votre espace client avec vos contrats et montants réels, quittez le mode démo.',
          loginButton: 'Quitter le mode démo',
        },
      },
    },
    selectOperation: {
      operationText: 'Je souhaite faire un {{operationType}} sur :',
      operationTextDefault: 'Je souhaite faire une opération sur :',
      selectSupportText: 'Souhaitez-vous effectuer le versement sur votre Gestion Pilotée ou sur un autre support ?',
      selectGPText: 'Veuillez sélectionner la Gestion Pilotée sur laquelle vous souhaitez effectuer un versement :',
      otherSupport:
        'Vous avez sélectionné la <span>Gestion Libre</span> et allez être redirigé vers votre espace gestionnaire',
      otherSupportWithTutorial:
        'Vous avez sélectionné la <span>Gestion Libre</span> et allez être redirigé vers votre espace gestionnaire. Un tuto vous guide si besoin.',
      arbitrationText: 'Vous allez être redirigé vers votre espace gestionnaire afin de procéder à l’opération.',
    },
    deposit: {
      title: 'Faire un versement',
      subtitle: 'Reversez rapidement et simplement sur votre Gestion pilotée.',
      label: 'Type de versement',
      depositObjectiveLabel: 'Objectif du versement',
      depositAmountLabel: 'Montant du versement',
      selectObjectiveLabel: 'Sélectionnez un objectif',
      fundsOriginLabel: 'Origine des capitaux',
      fundsOriginRequirement: `La règlementation nous impose de vous demander l'origine de vos fonds.`,
      debitAccountLabel: 'Vous serez prélevé sur ce compte',
      taxDeductionOptionLabel: 'Optez vous pour la déduction fiscale sur ce versement ?',
      situationConfirmationLabel: `Je confirme que ma situation n'a pas évolué depuis ma dernière opération (à défaut, je contacte mon conseiller).`,
      modalWording1:
        'Chaque versement est déductible fiscalement dans les limites et conditions prévues par la réglementation.',
      modalWording2: `Toutefois, vous avez la possibilité de renoncer à la déductibilité de votre investissement en sélectionnant la
        réponse correspondante. En cas de retrait, vous serez imposé uniquement sur la plus-value et non sur la totalité
        de votre épargne.`,
      originError: `Veuillez sélectionner l'origine de vos fonds`,
      confirmationError: 'Veuillez cocher la déclaration ci-dessus',
      errorTaxDeductionMessage: `Veuillez sélectionner l'une des options proposées`,
    },
    navigation: {
      home: 'Accueil',
      contracts: 'Mes contrats',
      operations: 'Mes opérations',
      invest: 'Investir',
      sponsorship: 'Parrainage',
      otherAccess: 'Mes autres accès',
      phoneNumber: '01 47 20 33 00',
      infoService: 'Service gratuit + prix d’un appel',
      help: `Besoin d'aide ?`,
      informations: 'Mes informations',
      logout: 'Déconnexion',
      mainMenuLabel: 'Menu de navigation',
      openMenu: 'Ouvrir le menu',
      closeMenu: 'Fermer le menu',
    },
    dropDownContrats: {
      allContracts: 'Tous les contrats',
      lifeInsurance: 'Assurance-Vie',
      taxExemption: 'Défiscalisation',
      retirement: 'Retraite (PER)',
      savingsAccount: 'Livret',
      realEstate: 'Immobilier',
      stockMarket: 'Bourse',
      label: 'Par gamme de produit',
    },
    alert: {
      title: 'Fin de la déduction fiscale de vos versements',
      description: `Depuis le 1er janvier 2026, les versements effectués à compter de vos 70 ans ne sont plus déductibles. En
          contrepartie, en cas de rachat en cours de vie, un régime fiscal spécifique et adapté sera appliqué.`,
    },
    demoMode: {
      tag: 'Données fictives',
      chartBanner: 'Démonstration — données fictives',
      sidebar: 'MODE DÉMONSTRATION',
      banner: {
        title: 'Mode démonstration',
        subtitle: 'Les données sont fictives et les modifications ne sont pas enregistrées.',
        subtitleMobile: 'Les données sont fictives',
        button: 'Quitter le mode démo',
        buttonMobile: 'Quitter',
      },
    },
    notificationCenter: {
      title: 'Notifications',
      noNotificationsTitle: 'Aucune notification',
      noNotificationsMessage: 'Vous serez informé ici dès qu’il y aura du nouveau.',
      closeButtonLabel: 'Fermer le panneau de notifications',
      openButtonLabel: 'Ouvrir le panneau de notifications',
      sections: {
        generalInformations: 'Information générale',
        offers: 'Les offres du moment',
        myOperations: 'Mes opérations',
      },
    },
    videoTutorials: {
      watchTutorials: 'Regarder les tutos',
      watchTutorialsLabel: 'Regarder les tutos {{partnerName}}',
      seeTutorials: 'Voir les tutoriels',
      exitGuide: 'Un tuto vous guide si besoin.',
      modalTitle: 'Tutos espace {{partnerName}}',
      interstitialTitle: 'Avant d’aller sur l’espace {{partnerName}}',
      interstitialText: 'Meilleurtaux a préparé les tutoriels pour vous guider sur l’espace gestionnaire.',
      hideTutorials: 'Ne plus afficher les tutos.',
      partnerAccessCta: 'Accéder à l’espace gestionnaire',
      closeButtonLabel: 'Fermer',
      playButtonLabel: 'Lancer la vidéo {{title}}',
      replayButton: 'Revoir',
      retryButton: 'Réessayer',
      errorMessage: 'Cette vidéo est momentanément indisponible.',
      tutoTitle: {
        versement: 'Tuto Versement {{partnerName}}',
        arbitrage: 'Tuto Arbitrage {{partnerName}}',
        rachat: 'Tuto Rachat {{partnerName}}',
      },
    },
    allocationAnalysis: {
      title: 'Analyse de votre allocation',
    },
    allocation: {
      yourProfile: 'Votre profil',
      yourAllocation: 'Votre allocation',
      before: 'Avant',
      after: 'Après',
      alignedAllocation: "L'allocation choisie est alignée avec votre allocation actuelle.",
      notAlignedAllocation: "L'allocation choisie vous expose à un risque supérieur à votre allocation actuelle.",
    },
    summaryArbitrage: {
      title: 'Arbitrage',
      pageTitle: "Proposition d'arbitrage",
      contract: 'Contrat',
      totalReinvested: 'Total réinvesti',
      totalFees: 'Frais totaux',
      detailSupports: 'Détail des supports',
      supportsDesinvestis: 'Supports désinvestis',
      supportsInvestis: 'Supports investis',
      noSupports: 'Aucun support à afficher.',
      allocationAnalysis: {
        profileDefaultValue: 'Prudent',
      },
      declineModal: {
        title: 'Refuser la proposition',
        intro: 'Votre décision sera transmise à votre conseiller.',
        description:
          'Il reste disponible pour vous accompagner et vous soumettre une nouvelle proposition si vous le souhaitez.',
        reviewProposalButton: 'Retour à la proposition',
        confirmDeclineButton: 'Confirmer le refus',
      },
      tabRecap: 'Récapitulatif',
      validateModal: {
        title: 'Votre allocation vous expose à un risque supérieur à votre profil investisseur',
        question: `Confirmez-vous cette allocation ?`,
        description: 'Votre profil de risque sera mis à jour automatiquement.',
        reviewProposalButton: 'Retour à la proposition',
        continueButton: 'Continuer',
      },
    },

    expiredProposalModal: {
      title: 'Cette proposition est expirée',
      description: 'La proposition d’arbitrage n’est plus disponible à la validation.',
      contactAdvisorText: 'Votre conseiller peut étudier une nouvelle proposition avec vous.',
      contactAdvisorButton: 'Contacter mon conseiller',
    },
    proposalAlert: {
      title: '{{contractName}}: consultez la proposition d’arbitrage',
      description: 'Votre conseiller vous propose d’ajuster les investissements de votre contrat.',
      labelButton: 'Voir la proposition',
    },
    walletArbitrage: {
      title: 'Récapitulatif de votre contrat',
      exitFees: 'Frais de sortie :',
      entryFees: "Frais d'entrée :",
      totalFees: 'Total des frais :',
    },
    arbitrageSummary: {
      title: "Proposition d'arbitrage",
      breadcrumbLabel: 'Mon arbitrage',
    },
    cardSupport: {
      moreInfo: "Plus d'informations",
      lessInfo: 'Voir moins',
      montantDesinvesti: 'Montant désinvesti',
      montantInvesti: 'Montant investi',
      pourcentage: '%',
      noteRisque: 'Note de risque',
      noteRisqueMax: '/ 7',
      performances: 'Performances',
      ytd: 'YTD',
      oneYear: '1 an',
      threeYears: '3 ans',
      fiveYears: '5 ans',
      ficheInfo: "Fiche d'information",
      lienAvenant: "l'avenant du support",
      lienAvenantSuffix: 'afin de prendre connaissance de ses spécificités.',
      nc: 'NC',
    },
    faireVersementCancel: {
      title: 'Votre abandon de versement a bien été pris en compte',
      subtitle: 'Vous ne serez pas prélevé.',
      cta: "Retourner à l'accueil",
    },
    faireVersementError: {
      title: "Votre demande de versement n'a pas pu aboutir",
      subtitle1: "Suite à un problème technique, votre opération n'a pas pu aboutir. Veuillez réessayer.",
      subtitle2: 'Si le problème persiste, veuillez contacter votre conseiller.',
      cta: 'Réessayer',
    },
    faireVersementFail: {
      title: 'Une erreur est survenue',
      subtitle: 'Veuillez contacter un conseiller afin de confirmer la prise en compte de votre versement.',
      cta: 'Contacter un conseiller',
    },
    faireVersementSucces: {
      title: 'Nous avons bien reçu votre demande de versement',
      subtitle: 'Votre nouveau versement apparaîtra dans les prochains jours sur votre compte.',
      cta: "Retourner à l'accueil",
    },
    propositionArbitrageBanner: {
      singleTitle: "{{contractName}} : consultez la proposition d'arbitrage",
      singleDescription: "Votre conseiller vous propose d'ajuster les investissements de votre contrat.",
      singleCta: 'Voir la proposition',
      multipleTitle: 'Arbitrages en attente',
      multipleDescription: "Votre conseiller vous propose d'ajuster les investissements de vos contrats.",
      multipleCta: 'Voir les propositions',
    },
    modalPropositionExpiree: {
      title: 'Cette proposition est expirée',
      line1: "La proposition d'arbitrage n'est plus disponible à la validation.",
      line2: 'Votre conseiller peut étudier une nouvelle proposition avec vous.',
      cta: 'Contacter mon conseiller',
    },
    universignCheckError: {
      title: 'Une erreur est survenue',
      subtitle: 'Impossible de vérifier votre identité. Veuillez réessayer.',
      cta: 'Réessayer',
    },
    cardResumeSubscription: {
      fallbackFamille: 'Souscription',
      startedOn: 'Commencée le',
      awaitingProfile: 'en attente de',
      awaitingProfileHighlight: 'votre profil investisseur.',
      forContract: 'pour le contrat',
      resumeButton: 'Reprendre ma souscription',
    },
    justificatifsUniversign: {
      pageTitle: 'Mes justificatifs',
      pageSubtitle1Bold: 'L’opération nécessite de vous créer une identité numérique',
      pageSubtitle1Rest: 'afin de garantir la sécurité de la transaction',
      pageSubtitle2Bold: 'Téléchargez une seule fois vos justificatifs',
      pageSubtitle2Rest: 'et passez automatiquement cette étape lors des prochains arbitrages ou versements.',
      mandatoryMentions: 'Mentions obligatoires',
      sectionTitle: 'Saisie de vos documents',
      goToSignature: 'Aller à la signature',
      contactAdvisor: 'Contacter un conseiller',
      accessAdvice: 'Accédez à nos conseils',
      accessAdviceSuffix: 'pour faciliter la validation de votre justificatif d’identité',
      documentTypeLabel: 'Justificatif d’identité',
      documentTypePasseport: 'Passeport',
      documentTypeCni: 'Ma carte d’identité',
      documentTypeCarteDeSejour: 'Carte de sejour',
      documentRecto: '(recto)',
      documentVerso: '(verso)',
      phoneBill: 'Facture de téléphone mobile',
      phoneLabel: 'N° de téléphone',
      phonePlaceholder: '06 00 00 00 00',
      origineFondsTitle: 'Justificatif d’origine de fonds',
      fileUploadError: 'Une erreur est survenue lors de l’envoi du fichier. Merci de réessayer.',
      fileRejectedError: 'Le fichier a été refusé par notre équipe',
      requiredField: 'Champs requis',
      emailVerificationModalTitle: 'Vérifiez votre email de signature électronique',
      emailVerificationCodeResent: 'Le code de vérification vient d’être renvoyé',
      emailVerificationResendError: 'Le code n’a pas pu être renvoyé, veuillez réessayer dans un instant',
      emailVerificationIntro: 'Veuillez saisir le code de vérification reçu à l’adresse :',
      emailVerificationCodeLabel: 'Code de vérification',
      emailVerificationCodePlaceholder: '123456',
      emailVerificationResend: 'Renvoyer le code',
      bonnesPratiquesTitle: 'Quelles sont les bonnes pratiques ?',
      serviceClientIntro:
        'Si le problème persiste ou que vos coordonnées ont changé, veuillez contacter notre Service Client au',
      errorIdTitle: 'Erreur avec la pièce d’identité',
      errorIdUnreadable: 'Nous n’avons malheureusement pas réussi à lire votre justificatif d’identité.',
      errorIdUnreadableAdvice:
        'Nous vous conseillons de re-télécharger votre justificatif d’identité, en veillant à ce que le document soit bien visible.',
      errorIdMismatch:
        'Notre prestataire de signature électronique n’a pas réussi à faire correspondre votre nom, prénom et/ou date de naissance avec les informations présentes sur votre justificatif d’identité :',
      errorIdMismatchAdvice:
        'Nous vous invitons à re-télécharger un fichier de meilleure qualité ou un autre justificatif d’identité.',
      errorIdExpired: 'La date de validation de votre justificatif d’identité est expirée.',
      errorIdExpiredAdvice:
        'Nous vous invitons à re-télécharger votre justificatif d’identité, en veillant à ce que le document soit bien en cours de validité.',
      readingErrors: {
        msg1: {
          title: 'Votre pièce d’identité n’est pas lisible',
          text: 'Nous n’avons pas pu vérifier votre pièce d’identité. Reprenez-la en photo à plat, bien éclairée, sans reflet, avec les 4 coins visibles.',
        },
        msg2: {
          title: 'Nous avons besoin de l’original',
          text: 'Votre document semble être une copie (photocopie, capture d’écran ou photo d’un écran). Prenez directement en photo votre pièce d’identité originale.',
        },
        msg3: {
          title: 'Une partie de votre pièce d’identité est illisible',
          text: 'Certaines informations de votre pièce d’identité n’ont pas pu être lues, notamment la bande de caractères en bas du document ou la date d’expiration. Vérifiez que le document est entièrement visible et net, sans doigt ni bord coupé.',
        },
        msg4: {
          title: 'Nous n’avons pas pu lire votre fichier',
          text: 'Votre fichier n’a pas pu être lu. Envoyez une photo nette au format JPG ou PNG, ou un PDF lisible.',
        },
        msg5: {
          title: 'Document non reconnu',
          text: 'Nous n’avons pas reconnu votre document. Sont acceptés : carte nationale d’identité, passeport ou titre de séjour en cours de validité. Vérifiez aussi que le type sélectionné correspond bien à votre document et que le recto et le verso sont dans le bon ordre.',
        },
        msg6: {
          title: 'La vérification n’a pas abouti',
          text: 'La vérification de votre pièce d’identité n’a pas pu aboutir. Merci de réessayer dans quelques instants. Si le problème persiste, essayez avec un autre justificatif, de préférence un passeport en cours de validité.',
        },
      },
      errorSignatureTitle: 'Erreur avec la signature électronique',
      errorSignatureEmailUsed:
        'Notre prestataire de signature électronique nous informe que vous avez déjà réalisé une signature avec un email différent :',
      errorSignatureEmailAdvice: 'Vous devez re-saisir cet email afin de valider votre signature électronique :',
      errorSignaturePhoneUsed:
        'Notre prestataire de signature électronique nous informe que vous avez déjà réalisé une signature avec un numéro de téléphone portable différent :',
      errorSignaturePhoneAdvice:
        'Vous devez re-saisir ce numéro de téléphone portable et re-télécharger votre facture de téléphone mobile afin de valider votre signature électronique :',
      errorSignatureBothUsed:
        'Notre prestataire de signature électronique nous informe que vos coordonnées ont déjà été utilisées par un précédent signataire.',
      errorSignatureBothAdvicePrefix: 'Nous vous invitons à contacter notre Service Client au',
      errorSignatureBothAdviceSuffix: 'afin qu’un conseiller vous indique la marche à suivre.',
      errorSignatureTechnical:
        'Suite à un problème technique, nous ne pouvons pas valider votre signature électronique en ligne.',
      emailMismatch: 'Cet adresse email a déjà été utilisée par un autre signataire. Veuillez en saisir une autre.',
      phoneMismatch:
        'Ce numéro de téléphone portable a déjà été utilisé par un autre signataire. Veuillez en saisir un autre.',
      coordonneesCodeSendError: 'Echec lors de l’envoi du code de vérification',
      emailSendError: 'Nous n’avons pas pu vérifier votre adresse email. Veuillez réessayer dans un instant.',
      phoneSendError:
        'Nous n’avons pas pu vérifier votre numéro de téléphone portable. Veuillez réessayer dans un instant.',
      emailMissingError: 'Aucune adresse email n’a été transmise. Veuillez la saisir à nouveau.',
      phoneMissingError: 'Aucun numéro de téléphone portable n’a été transmis. Veuillez le saisir à nouveau.',
      phoneGenericError: 'Une erreur est survenue lors de la vérification. Veuillez réessayer.',
      invalidCode: 'Code invalide',
      expiredCode: 'Ce code a expiré. Veuillez en demander un nouveau.',
      unknownCode: 'Nous n’avons pas retrouvé votre code. Veuillez en demander un nouveau.',
      missingCode: 'Aucun code n’a été transmis. Veuillez le saisir à nouveau.',
      unknownSouscription: 'Votre souscription est introuvable. Veuillez contacter notre Service Client au',
      codeGenericError: 'Une erreur est survenue lors de la vérification. Veuillez réessayer.',
      codeSendError: 'Erreur lors de l’envoi du code',
      invalidPhoneNumber: 'Veuillez rentrer un numéro valide',
      emailLabel: 'Email',
      emailPlaceholder: 'Adresse email',
      origineFondsRevenuLabel: 'Justificatif de revenu',
      origineFondsRevenuInfo: 'Les 6 derniers relevés bancaire ou votre bulletin de salaire.',
      origineFondsEpargneLabel: 'Justificatif d’épargne',
      origineFondsEpargneInfo:
        'Le dernier relevé de compte faisant apparaître la sortie des fonds ou relevé de situation du compte avant clôture ou transfert de moins de 3 mois.',
      origineFondsGainsJeuxLabel: 'Justificatif de gains aux jeux',
      origineFondsGainsJeuxInfo:
        'L’attestation de gain délivrée par l’organisme des jeux, ou la copie du chèque / avis de virement reçu de l’organisme des jeux.',
      origineFondsHeritageDonationLabel: 'Justificatif d’héritage/donation',
      origineFondsHeritageDonationInfo:
        'L’acte notarié de la déclaration de succession ou du formulaire Cerfa tamponné par l’administration fiscale et relevés du compte à débiter permettant d’attester de l’origine et de la traçabilité des fonds.',
      origineFondsCessionActifLabel: 'Justificatif de cession d’actif',
      origineFondsCessionActifInfo:
        'L’acte notarié, le protocole de cession ou l’attestation du notaire avec prix et relevés du compte à débiter permettant d’attester de l’origine et de la traçabilité des fonds.',
      origineFondsAutreLabel: 'Justificatif (Autre)',
      origineFondsAutreInfo: 'Tout élément permettant de démontrer la provenance des fonds.',
    },
    arbitrageSignature: {
      pageTitle: 'Signature électronique',
      subtitle: 'Il ne reste plus qu’à signer pour valider votre arbitrage.',
      summary: {
        title: 'Récapitulatif de votre demande :',
        contractName: 'NOM DU CONTRAT',
        montantArbitre: 'MONTANT ARBITRÉ',
        profilInvestisseur: 'PROFIL INVESTISSEUR',
        profilAllocation: 'PROFIL ALLOCATION',
      },
      success: {
        title: 'Votre arbitrage est validé.',
        subtitle: 'L’opération est transmise à votre assureur et sera visible sur votre contrat après traitement.',
        cta: 'Voir mon contrat',
      },
      error: {
        title: 'Votre arbitrage n’a pas pu être validé.',
        subtitle1: 'Suite à un problème technique, votre opération n’a pas pu aboutir.',
        subtitle2: 'Vous pouvez réessayer ultérieurement.',
        subtitle3: 'Votre conseiller reste disponible si le problème persiste.',
        cta: 'Contacter mon conseiller',
        ctaContract: 'Voir mon contrat',
      },
      unknown_error: {
        title: 'Une erreur est survenue',
        subtitle1: 'Veuillez contacter votre conseiller afin de confirmer la prise en compte de votre arbitrage.',
        cta: 'Contacter mon conseiller',
        ctaContract: 'Voir mon contrat',
      },
      refusal: {
        title: 'Votre refus de cet arbitrage a bien été pris en compte.',
        subtitle: 'Votre compte reste inchangé.',
        cta: 'Contacter mon conseiller',
        ctaContract: 'Voir mon contrat',
      },
    },
    qps: {
      breadcrumbLabel: 'Questionnaire de compréhension',
      intro: {
        overline_one: '{{count}} question',
        overline_other: '{{count}} questions',
        overlineMulti_one: 'Questionnaire {{index}} sur {{total}} · {{count}} question',
        overlineMulti_other: 'Questionnaire {{index}} sur {{total}} · {{count}} questions',
        title: 'Questionnaire de compréhension',
        subtitle:
          'Répondez aux questions pour vérifier votre compréhension du support choisi. Une fois le questionnaire réussi, vous pourrez poursuivre la validation de votre arbitrage.',
        isin: 'Code ISIN : {{isin}} · Spirica',
        start: 'Commencer le questionnaire',
        back: 'Retourner à la proposition',
      },
      answers: {
        true: 'Vrai',
        false: 'Faux',
      },
      question: {
        overlineMulti: 'Questionnaire {{index}} sur {{total}}',
        title: 'Ma connaissance de {{product}}',
        badge: 'Question {{current}}/{{total}}',
        next: 'Question suivante',
        results: 'Voir les résultats',
        avenant: 'Consulter l’avenant pour plus de détails sur ce support',
        avenantNewTab: '(PDF, nouvel onglet)',
      },
      feedback: {
        correctTitle: 'Bravo, en effet !',
        correctMessage: 'Votre réponse est correcte.',
        incorrectTitle: 'Dommage !',
        incorrectMessage: 'Votre réponse est incorrecte.',
      },
      notes: {
        title: 'Notes',
      },
      result: {
        successTitle: 'Questionnaire réussi !',
        successMessage:
          'Vous possédez une bonne connaissance du fonctionnement des marchés financiers et pouvez désormais investir dans {{product}}.',
        successMultiTitle: 'Questionnaire {{index}} sur {{total}} réussi !',
        successMultiMessage:
          'Vos réponses sur <b>{{product}}</b> sont validées. Pour poursuivre votre arbitrage, il vous reste un questionnaire à compléter sur <b>{{nextProduct}}</b>.',
        failTitle: 'Questionnaire non réussi',
        failMultiTitle: 'Questionnaire {{index}} sur {{total}} non réussi',
        failMessage:
          'Certaines de vos réponses ne correspondent pas aux caractéristiques de <b>{{product}}</b>. Vous pouvez retenter ce questionnaire pour poursuivre votre arbitrage.',
        contactQuestion: 'Une question sur votre arbitrage ?',
        contactLink: 'Nous contacter',
        continue: 'Continuer',
        nextQuestionnaire: 'Passer au questionnaire {{index}}',
        retry: 'Retenter le questionnaire',
        backToProposal: 'Retourner à la proposition',
      },
      unavailable: {
        title: 'Questionnaire momentanément indisponible',
        message:
          'Nous ne parvenons pas à charger le questionnaire sur <b>{{product}}</b>. Votre proposition d’arbitrage est conservée : vous pouvez réessayer dans quelques instants.',
        retry: 'Réessayer',
        backToProposal: 'Retourner à la proposition',
      },
      contactModal: {
        title: 'Nous contacter',
        subtitle:
          'Choisissez un des moyens de nous contacter pour apprendre davantage sur le produit structuré que vous avez choisi',
        chat: 'Chat',
        copyEmailLabel: "Copier l'adresse e-mail",
        emailCopied: 'E-mail copié',
      },
    },
  },
} as const;
